import Tablet from '@material-ui/icons/Tablet';
import Dashboard from './Dashboard';

export default {
  list: Dashboard,
  icon: Tablet,
};
